import nodeClient from "./node-client";

export const saveBranchGroup = async (payload) => {
  const response = await nodeClient.post(
    `/service/private/v0/branch/group/add`,
    payload
  );
  return response?.data?.result;
};

export const searchBranchGroup = async (payload) => {
  const response = await nodeClient.post(
    `/service/private/v0/branch/group/list`,
    payload
  );
  return response?.data?.result?.rows;
};

export const listBranchGroup = async () => {
  const response = await nodeClient.post(
    `/service/private/v0/branch/group/list`
  );
  return response?.data;
};
